import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import InfoIcon from "@mui/icons-material/Info";

import {setLookActiveCategory, setLookMoreInfoOpened, setLookOverlayOpened} from "../../../../../actions/lookFunctions";
import {LOOK_FEATURE_CONTENT, LOOK_OVERLAYS} from "../../../core/constants";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {IS_LOOK_JOURNEY, IS_PRODUCT_JOURNEY} from "../../../../../config";
import {getAvailableFeatureContent} from "../../../lookNavigation/lookFunctions2";

const GroheFeatureMoreInfoButton = (props) => {

  const {featureIsLocked, setLookMoreInfoOpened, moreInfoOpened, moreInfoContent, lookActiveCategory, lookActiveFeature,
    setLookOverlayOpened, isWizard} = props;

  if (IS_LOOK_JOURNEY && isWizard) {
    return null
  }

  const moreInfoClick = () => {
    if (IS_PRODUCT_JOURNEY) {
      Analytics.sendClickEvent(moreInfoOpened
        ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureMoreInfoClose
        : PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureMoreInfoOpen
      );
    } else {
      Analytics.sendClickEvent(moreInfoOpened
        ? LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureMoreInfoClose
        : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureMoreInfoOpen
      );
    }
    if (featureIsLocked) {
      setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
      return false
    }
    const moreInfoType = moreInfoOpened && (moreInfoContent === LOOK_FEATURE_CONTENT.info)
      ? ""
      : lookActiveCategory && !IS_PRODUCT_JOURNEY ? "select" : "main";
    //setLookActiveCategory("");
    setLookMoreInfoOpened(moreInfoType, LOOK_FEATURE_CONTENT.info);
  };

  return (
    <span className="lk-feature__price-info">
      <Button className={"look-button look-button--small look-button--tertiary"
        + (IS_PRODUCT_JOURNEY ? " grohe-look__button--small" : "")}
              size="small"
              disabled={!getAvailableFeatureContent(lookActiveFeature).length}
              startIcon={<InfoIcon fontSize="small"/>}
              onClick={moreInfoClick}>
        <FormattedMessage id={moreInfoOpened && (moreInfoContent === LOOK_FEATURE_CONTENT.info)
          ? "look.feature.lessInfoButton" : "look.feature.moreInfoButton"}/>
      </Button>
    </span>
  )
};

GroheFeatureMoreInfoButton.propTypes = {
  isWizard: PropTypes.bool,
}

const mapStateToProps = (store) => {
  const {moreInfoOpened, moreInfoContent} = store.lookState;
  const {lookActiveCategory, lookActiveFeature} = store.lookState;
  return {
    moreInfoOpened,
    moreInfoContent,
    lookActiveCategory,
    lookActiveFeature,
  };
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setLookMoreInfoOpened,
  setLookOverlayOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheFeatureMoreInfoButton)
